// app/(main)/orgs/[slug]/_components/OrgShareButton.tsx
"use client";

import { Share2 } from "lucide-react";

export default function OrgShareButton({ orgName }: { orgName: string }) {
  function handleShare() {
    const url = window.location.href;
    if (navigator.share) {
      navigator.share({ title: orgName, url }).catch(() => {});
    } else {
      navigator.clipboard.writeText(url);
      // Optional: toast notification
    }
  }

  return (
    <button
      onClick={handleShare}
      title={`Share ${orgName}`}
      className="w-10 h-10 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-white/70 hover:bg-white/20 transition-colors shrink-0"
    >
      <Share2 className="w-4 h-4" />
    </button>
  );
}